import React from 'react';
import { Col, Row } from 'react-bootstrap-5';
import AiBadge from '../../call_list/owners/ai_badge';
import LlcMatchBadge from '../../call_list/owners/llc_match_badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import pluralize from 'pluralize';
import type { Ownerships } from 'bundles/connect/types';
import { faEnvelopesBulk, faMobileRetro } from '@fortawesome/pro-regular-svg-icons';
import AssessorMatchBadge from '../../call_list/owners/assessor_match_badge';

type Props = {
  owner: Ownerships;
}

export default function OwnerNameDisplay({ owner }: Props) {
  return (
    <Row className="flex-column gap-1">
      <Col>
        <div className="text-body privacy-mask mb-0">{owner.contact.name}</div>
      </Col>
      {(owner.llcMatch || owner.aiVerified || owner.aiSourced || owner.assessorMatch) && (
        <Col className="d-flex gap-1">
          {(owner.aiVerified || owner.aiSourced) && (
            <AiBadge sources={owner?.aiSources ?? []} verified={owner.aiVerified} />
          )}
          {owner.llcMatch && <LlcMatchBadge />}
          {owner.assessorMatch && <AssessorMatchBadge />}
        </Col>
      )}
      <Col>
        {owner.contact.phoneNumbers.length == 0 && owner.contact.emails.length == 0 && (
          <small className=" d-flex align-items-center gap-1 text-muted fw-normal">
            <FontAwesomeIcon icon={faPersonCircleQuestion} />
            No Contact Information
          </small>
        )}
        {(owner.contact.phoneNumbers.length > 0 || owner.contact.emails.length > 0) && (
          <small className=" d-flex align-items-center gap-3 text-muted fw-normal">
            {owner.contact.phoneNumbers.length > 0 && (
              <div className="d-flex align-items-center gap-1">
                <FontAwesomeIcon icon={faMobileRetro} />
                <span>{owner.contact.phoneNumbers.length} {pluralize('Phone', owner.contact.phoneNumbers.length)}</span>
              </div>
            )}
            {owner.contact.emails.length > 0 && (
              <div className="d-flex align-items-center gap-1 fw-normal">
                <FontAwesomeIcon icon={faEnvelopesBulk} />
                <span>{owner.contact.emails.length} Email {pluralize('Address', owner.contact.emails.length)}</span>
              </div>
            )}
          </small>
        )}
      </Col>
    </Row>
  );
}
